const system = {
    namespaced: true,
    state: {
        navPosition: "0",
    },
    mutations: {
        SET_NAVPOSITION: (state, navPosition) => {
            state.navPosition = navPosition
        },
    }
}

export default system

